export const DEFAULT_AUTHOR_LOGO = 'author-default-logo.svg'
export const DEFAULT_THUMBNAIL_IMAGE = 'il-thumbnail.png'
